(function () {
  function setupSiteSearch() {
    var modal = document.querySelector('[data-kn-site-search-modal]');
    if (!modal || modal.dataset.knSearchReady) return;
    modal.dataset.knSearchReady = 'true';

    var input = modal.querySelector('input[type="search"]');
    var opener = null;
    var closeButton = modal.querySelector('.kn-home-search-modal__close');

    document.querySelectorAll('.header-search-1 .search-icon').forEach(function (trigger) {
      trigger.setAttribute('role', 'button');
      trigger.setAttribute('tabindex', '0');
      trigger.setAttribute('aria-label', 'Search prints');
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        trigger.click();
      });
    });

    function close() {
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('kn-search-modal-open');
      if (opener && opener.isConnected) opener.focus({ preventScroll: true });
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('.header-search-1 .search-icon');
      if (!trigger) return;

      event.preventDefault();
      event.stopPropagation();
      opener = trigger;
      document.querySelectorAll('.header-search-1.search-open, .header-search-1-form.search-open').forEach(function (element) {
        element.classList.remove('search-open');
      });
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('kn-search-modal-open');
      if (input) window.setTimeout(function () { input.focus(); }, 40);
    }, true);

    modal.addEventListener('click', function (event) {
      if (event.target.closest('[data-kn-site-search-close]')) close();
    });

    document.addEventListener('keydown', function (event) {
      if (modal.hidden) return;
      if (event.key === 'Escape') close();
      if (event.key === 'Tab') {
        if (event.shiftKey && document.activeElement === closeButton) {
          event.preventDefault();
          modal.querySelector('.kn-home-search-modal__shortcuts a:last-child')?.focus();
        } else if (!event.shiftKey && document.activeElement === modal.querySelector('.kn-home-search-modal__shortcuts a:last-child')) {
          event.preventDefault();
          closeButton?.focus();
        }
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupSiteSearch, { once: true });
  else setupSiteSearch();
  document.addEventListener('shopify:section:load', setupSiteSearch);
})();
